import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Smartphone } from 'lucide-react';

// Bridges web redirects (payments, Google sign-in) back into the SalesSpace Pro app
export default function AppReturnPage() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/app-return\/?/, '');
  const deepLink = `salesspacepro://${path}${location.search}${location.hash}`;

  useEffect(() => {
    window.location.href = deepLink;
  }, [deepLink]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-6 text-center bg-slate-950 text-white" data-testid="app-return-page">
      <Smartphone className="w-12 h-12 text-blue-400" />
      <h1 className="text-2xl font-bold">Returning to SalesSpace Pro</h1>
      <p className="text-slate-400 max-w-sm">If the app doesn't open automatically, tap the button below.</p>
      <a href={deepLink} className="rounded-full bg-blue-600 px-6 py-3 font-semibold hover:bg-blue-500 transition-colors" data-testid="app-return-open-btn">
        Open SalesSpace Pro
      </a>
    </div>
  );
}
